import React from 'react';
import './TalkToTeam.css';
import { bgImageSet } from './bgImageSet';
import TeamBackground from 'url:../../assets-optimized/contact_us_cta.jpg';
import TeamBackgroundAvif from 'url:../../assets-optimized/contact_us_cta.avif';
import TeamBackgroundWebp from 'url:../../assets-optimized/contact_us_cta.webp';
import TeamBackgroundMobile from 'url:../../assets-optimized/contact_us_cta_mobile.jpg';
import TeamBackgroundMobileAvif from 'url:../../assets-optimized/contact_us_cta_mobile.avif';
import TeamBackgroundMobileWebp from 'url:../../assets-optimized/contact_us_cta_mobile.webp';
import ActionButton from '../elements/ActionButton/ActionButton';

const TalkToTeam = () => {
  return (
    <div
      className='talk-team-section'
      style={{
        '--bg-desktop': bgImageSet({
          avif: TeamBackgroundAvif,
          webp: TeamBackgroundWebp,
          fallback: TeamBackground,
        }),
        '--bg-mobile': bgImageSet({
          avif: TeamBackgroundMobileAvif,
          webp: TeamBackgroundMobileWebp,
          fallback: TeamBackgroundMobile,
        }),
      }}
    >
      <div className='talk-team-card'>
        <h2>
          Talk to
          <br />
          Our Team
        </h2>
        <p>We'd love to talk more about how our unique set of offerings can benefit your brand.</p>
        <div className='talk-team-buttons'>
          <ActionButton to='/contact' text='Contact Us' className='dark' size='sm' />
        </div>
      </div>
    </div>
  );
};

export default TalkToTeam;
